import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import MobileBottomNav from "./MobileBottomNav";
import { useMe } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nProvider";

function OnboardingGate() {
  const { me } = useMe();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (me && !me.account_type && pathname !== "/onboarding" && !pathname.startsWith("/page/")) {
      navigate(`/onboarding?next=${encodeURIComponent(pathname + search)}`, { replace: true });
    }
  }, [me, pathname, search, navigate]);
  return null;
}

function AccountBanner() {
  const { error } = useMe();
  const { t } = useI18n();
  if (!error || !String(error).startsWith("account_")) return null;
  return <div data-testid="account-status-banner" className="bg-red-700 text-white text-center text-sm py-2">{t(`errors.${error}`)}</div>;
}

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="has-bottom-nav min-h-screen flex flex-col">
      <Header />
      <AccountBanner />
      <OnboardingGate />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}
